// export const BASE_URL = "http://localhost:5000";
// export const BASE_URL = "http://52.23.3.146"
export const BASE_URL = "https://gustyglow.com/api"
// export const BASE_URL = "http://65.1.182.14/api"
